module.exports = __webpack_public_path__ + "static/media/calendar-regular.cd82985e.svg";